import { render, staticRenderFns } from "./TX.vue?vue&type=template&id=70d51e88&scoped=true&"
import script from "./TX.vue?vue&type=script&lang=js&"
export * from "./TX.vue?vue&type=script&lang=js&"
import style0 from "./TX.vue?vue&type=style&index=0&id=70d51e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d51e88",
  null
  
)

component.options.__file = "TX.vue"
export default component.exports